var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.288 484.616L204.184 156.52c-15.677-15.283-40.728-15.122-56.208 0.36-15.48 15.482-15.637 40.533-0.352 56.208l299.8 299.816-299.816 299.80799999a40.002 40.002 0 1 0 56.568 56.57600001L532.288 541.184c15.615-15.62 15.615-40.94 0-56.56l0-0.008z m344 0L548.184 156.51999999c-15.677-15.283-40.728-15.122-56.208 0.36000001-15.48 15.482-15.637 40.533-0.352 56.208l299.80000001 299.816-299.81600001 299.808a40.002 40.002 0 1 0 56.568 56.576L876.288 541.184c15.615-15.62 15.615-40.94 0-56.56l0-0.008z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double-arrow-right.f83a56bc03d1bd9666519440d08c3436.svg";
export { ForwardRef as ReactComponent };